module.exports = __webpack_public_path__ + "img/light_logo.3818eb4b.png";